
// Libraries
import { Component, Prop, Vue } from "nuxt-property-decorator";

@Component({})
export default class TableHeaderAtom extends Vue {
  @Prop() content: string | number;
  @Prop({ default: false }) isPelletsSite: boolean;
}
